import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import { brands, colors, Icon } from "assets";

import "./loader.css";

class LoaderView extends Component {
  render() {
    return (
      <div
        className="layout-full-height grid-container"
        id="login"
        style={{
          background: `radial-gradient(ellipse farthest-corner at 50% 100% , ${colors.background.normal} 20%, ${colors.background.dark} 90%)`
        }}
      >
        <Row className="layout-full-height" middle="xs">
          <Col xs={12}>
            <div className="text-center">
              <img
                src={brands.png.primary}
                height="80"
                alt="PDVend"
                className="pdvend-logo"
              />
            </div>
            <div className="text-center">
              <Icon.LoaderIcon style={{ width: 100, height: 100 }} />
            </div>
            <div className="text-center">
              <p className="loader-text">Carregando...</p>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default LoaderView;



// WEBPACK FOOTER //
// ./src/components/app/loader/index.jsx